<template>
  <div>    
    <div class="main" style="background-image:url(static/img/act/7/banner/bg.jpg)" >
      <div class="act-7-banner-title-wrap">
        <img class="act-7-banner-title-bg " src="static/img/act/7/banner/title-bg.png">   
        <img v-show="isShow" class="act-7-banner-title act-7-animation-banner-title" src="static/img/act/7/banner/title.png">  
        <img v-show="isShow" class="act-7-banner-title-desc act-7-animation-banner-title-desc" src="static/img/act/7/banner/title-desc.png">  
        
        <router-link to="/act7/main">
          <img class="act-7-banner-btn-frog act-7-animation-btn-frog" src="static/img/act/7/banner/btn-frog.png"> 
        </router-link>
        <img v-show="isShow" class="act-7-banner-dragonfly act-7-animation-dragonfly" src="static/img/act/7/banner/dragonfly.png">   
      </div> 
      <div class="act-7-banner-lotus-wrap">
        <img class="act-7-banner-lotus-1 act-7-animation-lotus-1" src="static/img/act/7/banner/lotus-1.png">     
        <img class="act-7-banner-fish" src="static/img/act/7/banner/fish.png">      
        <img class="act-7-banner-lotus-leaves" src="static/img/act/7/banner/lotus-leaves.png">   
        <img class="act-7-banner-lotus-2 act-7-animation-lotus-2" src="static/img/act/7/banner/lotus-2.png">         
        <img class="act-7-banner-lotus-3 act-7-animation-lotus-2" src="static/img/act/7/banner/lotus-3.png">     
        <img class="act-7-banner-lotus-4 act-7-animation-lotus-1" src="static/img/act/7/banner/lotus-4.png">    
        <img class="act-7-banner-leaves-1" src="static/img/act/7/banner/leaves-1.png">     
        <img class="act-7-banner-leaves-2" src="static/img/act/7/banner/leaves-2.png">    
        <img class="act-7-banner-leaves-3" src="static/img/act/7/banner/leaves-3.png">   
        <img class="act-7-banner-leaves-4" src="static/img/act/7/banner/leaves-4.png">         
      </div>
    </div>    
  </div>
</template>
 

<script>
import NavTabbar from '@/components/NavTabbar.vue' 
import { ImagePreview } from "vant";
//动画
import Velocity from "velocity-animate";

export default {
  name: "Act6Banner",
  components: {
    'nav-tabbar': NavTabbar,   
    "van-image-preview": ImagePreview
  },
  data() {
    return {
      isShow:false,
    };
  },
  mounted() {
  },
  created() {    
    let vm = this
    //移除loading
    if(this.removeLoader()){
      setTimeout(function(){
        vm.isShow = true
      },2000)   
    } else {
      vm.isShow = true
    }
    this.setDocumentV2(
      "夏日赏荷卷",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/7/share.jpg?v=2"
    );
    _czc.push(['_trackEvent', '夏日赏荷卷', '点击', 'Banner页面','0','7']);  
    //动画

  },
  methods: {
    handleVeforeEnter: (el) => {
      //console.log('动画开始前')
      //el.style.opacity = 0   
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {  
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden;
}


/* 大标题 */

.act-7-banner-title-wrap {
  position: absolute;
  width: 51%;
  left: 3%;
  top: 12%;
}

.act-7-banner-title-bg {
  position: relative;
  width: 100%;
}



 
@-webkit-keyframes act-7-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes act-7-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.act-7-animation-banner-title {
  -webkit-animation-name: act-7-fadeIn;
  animation-name: act-7-fadeIn;
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-7-fadeIn 0.8s ease-in-out both;
  animation: act-7-fadeIn 0.8s ease-in-out both;
}

 
 
.act-7-banner-title {
    position: absolute;
    top: 8%;
    left: 6%;
    width: 88%;
    max-width: 100%;
}

.act-7-animation-banner-title-desc {
  -webkit-animation-name: act-7-fadeIn;
  animation-name: act-7-fadeIn;
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-7-fadeIn 0.8s ease-in-out both;
  animation: act-7-fadeIn 0.8s ease-in-out both;
  animation-delay: 300ms;
  -webkit-animation-delay: 300ms;
}

 
.act-7-banner-title-desc {
    position: absolute;
    top: 57%;
    left: 6%;
    width: 67%;
    max-width: 100%;
}
/* 大标题 end */

/* 青蛙 */
@keyframes act-7-frames-btn-frog {
  60% { 
    -webkit-transform: scale(1);
    transform:  scale(1);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
  70% {
    -webkit-transform: scale(0.8);
    transform:  scale(0.8);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
  80% { 
    -webkit-transform: scale(1);
    transform:  scale(1);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  } 
  90% {
    -webkit-transform: scale(0.8);
    transform:  scale(0.8);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
  100% {
    -webkit-transform: scale(1);
    transform:  scale(1);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
}


.act-7-animation-btn-frog {
  -webkit-animation-name: act-7-frames-btn-frog;
  animation-name: act-7-frames-btn-frog;
  -webkit-animation: act-7-frames-btn-frog 2.5s ease-in-out infinite;
  -moz-animation: act-7-frames-btn-frog 2.5s ease-in-out infinite;
  animation: act-7-frames-btn-frog 2.5s ease-in-out infinite;
}

.act-7-banner-btn-frog{    
  position: absolute;
  top: 75%;
  left: 6%;
  width: 55%;
  max-width: 100%;
  z-index: 2;
} 

/* 青蛙 end */
 




/* 蜻蜓 */

@keyframes act-7-frames-dragonfly {
  0% { 
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  } 
  100% {
    -webkit-transform: translateY(330%)  translateX(-300%);
    -webkit-transform-origin: center center;        
    transform:  translateY(330%)  translateX(-300%);
    transform-origin: center center;
  }
}

.act-7-animation-dragonfly {    
  -webkit-animation: act-7-frames-dragonfly 2s linear both;  
  animation: act-7-frames-dragonfly 2s linear both;
  animation-delay: 100ms;
  -webkit-animation-delay: 100ms;
}

.act-7-banner-dragonfly{  
  position: absolute;
  width: 30%;
  max-width: 100%;
  left: 167%;
  top: -51%;
}

/* 蜻蜓 end */





/* 荷叶群 */
.act-7-banner-lotus-wrap{
  position: absolute;
  width: 100%;
  left: 0;
  top: 27%;
}
.act-7-banner-lotus-leaves {
  width: 100%;
  max-width: 100%;
}
/* 荷叶群 end */



/* fish */
.act-7-banner-fish {
  position: absolute;
  width: 30%;
  left: 36%;
  top: 38%;
}
/* fish end */


/* 荷花 */


@keyframes act-7-frames-lotus-1 {
  0% { 
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  50% {
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  100% {
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
}
@-webkit-keyframes act-7-frames-lotus-1 {
  0% { 
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  50% {
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  100% {
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
}


.act-7-animation-lotus-1 { 
  -webkit-animation: act-7-frames-lotus-1 2.5s ease-out infinite; 
  animation: act-7-frames-lotus-1 2.5s ease-out infinite;
}

.act-7-banner-lotus-1 {
  position: absolute;
  width: 27%;
  left: 67%;
  top: -19%;
  transform:rotate(-5deg);
  -webkit-transform:rotate(-5deg);
}



@keyframes act-7-frames-lotus-2 {
  0% { 
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  50% {
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  100% {
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
}
@-webkit-keyframes act-7-frames-lotus-2 {
  0% { 
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  50% {
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  100% {
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
}

.act-7-animation-lotus-2 { 
  -webkit-animation: act-7-frames-lotus-2 2.5s ease-out infinite; 
  animation: act-7-frames-lotus-2 2.5s ease-out infinite;
}

.act-7-banner-lotus-2 {
  position: absolute;
  width: 17%;
  left: 61%;
  top: 14%;
  transform:rotate(5deg);
  -webkit-transform:rotate(5deg);
}


.act-7-banner-lotus-3 {
  position: absolute;
  width: 33%;
  left: 11%;
  top: 34%;
  transform:rotate(-5deg);
  -webkit-transform:rotate(-5deg);
}

 
.act-7-banner-lotus-4 {
  position: absolute;
  width: 15%;
  left: 51%;
  top: 56%;
  transform:rotate(5deg);
  -webkit-transform:rotate(5deg);
}
/* 荷花 end */


/* 荷叶 */
.act-7-banner-leaves-1 {
  position: absolute;
  width: 27%;
  left: 67%;
  top: 35%;
}
.act-7-banner-leaves-2 {
  position: absolute;
  width: 30%;
  left: 44%;
  top: 78%;
}
.act-7-banner-leaves-3 {
  position: absolute;
  width: 49%;
  left: 0;
  top:79.5%;
}
.act-7-banner-leaves-4 {
  position: absolute;
  width: 40%;
  right: 0;
  top: 82%;
}
/* 荷叶 end */ 
</style>


// WEBPACK FOOTER //
// src/components/act/7/Banner.vue